import { render, staticRenderFns } from "./BlockPairObjects.vue?vue&type=template&id=35723c0c&scoped=true"
import script from "./BlockPairObjects.vue?vue&type=script&lang=js"
export * from "./BlockPairObjects.vue?vue&type=script&lang=js"
import style0 from "./BlockPairObjects.vue?vue&type=style&index=0&id=35723c0c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35723c0c",
  null
  
)

export default component.exports